import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../../core/hooks';
import { isValidCustomerId } from '../../../../customers';
import { ChartSettings } from '../../../chart-settings/model';
import { getMonitoredDevices } from '../../api';
import { CpeMonitoredDevicesQuery } from '../../config';
import { MonitoredDeviceModel } from '../../model';

export const useMonitoredDevicesApiGet = (
  customerId: number | null,
  chartSettings: ChartSettings
): UseQueryResult<MonitoredDeviceModel[] | null, Error> => {
  const axios = useAuthorizedAxios();
  return useQuery<MonitoredDeviceModel[] | null, Error>({
    queryKey: [CpeMonitoredDevicesQuery['GetMonitoredDevices'].key, customerId, chartSettings.timespan],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        return await getMonitoredDevices(axios, { customerId, timespan: chartSettings.timespan });
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false,
  });
};